export default __webpack_public_path__ + "static/media/25.f551f11c.jpg";